export default __webpack_public_path__ + "static/media/p3.7ad0f300.svg";